import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import MButton from "Utils/Helpers/MButton";
import GetIcon from "Utils/Helpers/GetIcon";
import MInfoShow from "Utils/Helpers/MInfoShow";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import {
  setHomeData,
  setSocialData,
} from "../../../../../Redux/slices/mngrSlice";
import { delete_social } from "http/components/Social";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeleteSocialData({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onDelete = async () => {
    dispatch(HandleLoading(true));
    const response = await delete_social(row.id);
    if (CheckApiStatus(response)) {
      dispatch(setSocialData(true));
      enqueueSnackbar("Delete Success", { variant: "success" });
    }
    setShow(false);
    dispatch(HandleLoading(false));
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Trash3 size={16} />}
        label="Delete"
        onClick={setShowDialog}
        className="btn-manager btn-delete"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"xs"}
          onClose={handleClose}
          aria-describedby="alert-dialog-delete"
        >
          <DialogTitle>{`Delete (${row.name})`}</DialogTitle>
          <DialogContent>
            {show && (
              <>
                <p>Are you sure you want to delete the information?</p>
                <div className="m-delete-data">
                  <MInfoShow label={"Name"} data={row.name} />
                  <MInfoShow label={"Link"} data={row.link} />
                  <MInfoShow
                    label={"Icon"}
                    data={<>{row.icon} <GetIcon iconKey={row.icon} /></>}
                  />
                </div>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Delete"}
              color="danger"
              className="flex-grow-1"
              onClick={onDelete}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
